export default "__VITE_ASSET__3uzQcSr9__"